import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { LetDirective } from '@ngrx/component';

import { AvatarModule } from '@lockton-apps/shared/ui/lui';
import { CobMetaPipe } from '@lockton-apps/shared/ui/pipes';
import { GetPipe } from '@lockton-apps/shared/util/ng-lodash';

import { DynamicTableColumnTemplate } from '../column-template.directive';

interface CobTitleProps {
  size: number;
  path: string;
  subtitlePath: string;
}

@Component({
    selector: 'la-cob-title',
    imports: [
        CommonModule,
        AvatarModule,
        MatIconModule,
        CobMetaPipe,
        LetDirective,
        GetPipe,
    ],
    templateUrl: './cob-title.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CobTitleComponent extends DynamicTableColumnTemplate<CobTitleProps> {}
